<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">

        <b-button block v-b-toggle.term-section-7
          class="text-left fw-500 d-flex align-items-center justify-content-between">
              <div>
                  <span class="box-numbering">07</span>
                  <span>Card Expiry and Termination</span>    
              </div>
              <span 
                  class="toggle-icon" 
                  :class="{ active: isOpen }"
              >
                  <span class="plus">+</span>
                  <span class="cross">×</span>
              </span> 
        </b-button>

      </b-card-header>
      <b-collapse
        id="term-section-7"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify">
            Your {{ companyName }} card has an expiry date, which will be printed on the
            card. Upon expiration, the remaining balance may be transferred to a
            new card, subject to applicable fees.
          </p>
          <p class="text-justify">
            We reserve the right to suspend or terminate your card or account if
            you violate these Terms or engage in fraudulent or suspicious
            activity.
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "term-5",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
